export const DefaultPromo = (): IPromo => {
    return {
        effectiveEndDate: new Date(),
        effectiveStartDate: new Date(),
        productIds: [],
        dealInfo: DefaultDealInfo(),
        conditions: DefaultConditions(),
        promoMaterial: DefaultPromoMaterial(),
        id: '',
        name: '',
        sku: '',
        requiresValidation: false
    };
};

export interface IPromo {
    id: string;
    name: string;
    effectiveStartDate: Date;
    effectiveEndDate: Date;
    productIds: string[];
    dealInfo: IDealInfo;
    promoMaterial: IPromoMaterial;
    conditions: IConditions;
    sku: string;
    requiresValidation: boolean;
}

export interface IDealInfo {
    title: string;
    descriptions: string[];
    discount: IDiscount;
    lineDiscounts: ILineDiscount[];
}

export const DefaultDealInfo = (): IDealInfo => {
    return {
        descriptions: [],
        discount: DefaultDiscount(),
        title: '',
        lineDiscounts: []
    };
};

export interface IDiscount {
    value: number;
    type: DiscountType;
}

export const DefaultDiscount = (): IDiscount => {
    return {
        type: DiscountType.FlatAmount,
        value: 0
    };
};

export interface ILineDiscount {
    lineNumber: number;
    type: DiscountType;
    value: number;
}

export interface IConditions {
    isBundle: boolean;
    assurance: boolean;
    tradeIn: boolean;
    tradeInValueMinimum: number;
    deductTradeInFromPromo: boolean;
    downPayment: boolean;
    downPaymentMinimum: number;
    bogoConditions: IBogoConditions;
    tradeInThresholds: ITradeInThreshold[];
}

export const DefaultConditions = (): IConditions => {
    return {
        isBundle: false,
        assurance: false,
        bogoConditions: DefaultBogoConditions(),
        downPayment: false,
        downPaymentMinimum: 0,
        tradeIn: false,
        tradeInValueMinimum: 0,
        deductTradeInFromPromo: false,
        tradeInThresholds: []
    };
};

export interface ITradeInThreshold {
    minTradeInValue: number;
    maxTradeInValue: number | null;
    maxDiscountAmount: number;
}

export interface IBogoConditions {
    hasBogo: boolean;
    assurance: boolean;
    requiredPlans: string[];
    assignedIndividually: boolean;
    eligibleProducts: { [key: string]: string[] };
}

export const DefaultBogoConditions = (): IBogoConditions => {
    return {
        assignedIndividually: false,
        assurance: false,
        eligibleProducts: {},
        hasBogo: false,
        requiredPlans: []
    };
};

export interface IPromoMaterial {
    image: string;
    title: string;
    subTitle: string;
    description: string;
    backgroundColor: string;
    buttonText: string;
    textColor: string;
    linkAddress: string;
    promoMaterialCardType: PromoMaterialCardType;
    category: string;
}

export const DefaultPromoMaterial = (): IPromoMaterial => {
    return {
        backgroundColor: '',
        textColor: '',
        buttonText: '',
        category: '',
        description: '',
        image: '',
        linkAddress: '',
        promoMaterialCardType: PromoMaterialCardType.spotlight,
        subTitle: '',
        title: ''
    };
};

export enum PromoMaterialCardType {
    spotlight,
    tall,
    square,
    Discount
}

export enum DiscountType {
    FlatAmount,
    Percent
}
